import { UnionMap } from '../types/union-map';

// TODO: Task 2443329: Update add-ons to use Data plane SDK package when available
export type DevBoxHyperVProvisioningState = 'Creating' | 'Deleting' | 'Unknown' | 'Succeeded' | 'Failed';

export const DevBoxHyperVProvisioningState: UnionMap<DevBoxHyperVProvisioningState> = {
    Creating: 'Creating',
    Deleting: 'Deleting',
    Unknown: 'Unknown',
    Succeeded: 'Succeeded',
    Failed: 'Failed',
};

// TODO: Task 2443326: Replace pool URI with actual 1ES pool URI
export const HyperVDogfoodingProjectUri =
    'https://72f988bf-86f1-41af-91ab-2d7cd011db47-linux-devcenter.centraluseuap.devcenter.azure.com/projects/Linux_Dogfooding';

export const HyperVDogfoodingInstructionsLink = 'https://aka.ms/devbox/linuxdogfooding/instructions ';

export const LinuxName = 'Linux';

export const UbuntuImageName = 'Ubuntu 22.04';

export type DevBoxAddOnType = 'DevBoxHyperV' | 'DevBoxTunnel';

export const DevBoxAddOnType: UnionMap<DevBoxAddOnType> = {
    DevBoxHyperV: 'DevBoxHyperV',
    DevBoxTunnel: 'DevBoxTunnel',
};

// TODO: Task 2443329: Update add-status to use Data plane SDK package when available
export type DevBoxHyperVStatus = 'Unknown' | 'Starting' | 'Running' | 'Stopping' | 'Stopped';

export const DevBoxHyperVStatus: UnionMap<DevBoxHyperVStatus> = {
    Unknown: 'Unknown',
    Starting: 'Starting',
    Running: 'Running',
    Stopping: 'Stopping',
    Stopped: 'Stopped',
};
